import { render, staticRenderFns } from "./HeartMeasurements.vue?vue&type=template&id=9e326de8"
import script from "./HeartMeasurements.vue?vue&type=script&lang=ts"
export * from "./HeartMeasurements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/organs/heart/_locales/HeartMeasurements.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Forgans%2Fheart%2FHeartMeasurements.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports